<template>
  <div class="record-menu">
    <v-menu right bottom>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon color="#B6C1CB">more_vert</v-icon>
        </v-btn>
      </template>

      <v-list class="my-vlist" dense>
        <v-list-item class="my-vlistitem" @click="removeTimeline">
          <v-list-item-title class="my-vlistitemtitle">
            <v-icon class="menu-icons">visibility_off</v-icon>Remove from timeline
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "LogSubmenu",
  props: ["logId", "parentType", "storeKey"],
  methods: {
    removeTimeline() {
     
      axios
        .post("https://tradeinpool.com:3001/api/update/Logs", {
          document: "Logs",
          documentId: this.logId,
          parentDocument: this.parent,
          parentId: this.$route.params.id,
          key: "active",
          newValue: false,
          type: "deleteTimeline"
        })
        .then(() => {
          this.loading = false;
          this.edit = false;
          this.$emit("hideLog", this.logId);
        })
        .catch(err => {
          alert(err);
        });

     
    },
  }
};
</script>

<style>
</style>